export default __webpack_public_path__ + "static/media/coin.4c6feabd.svg";